module.exports = __webpack_public_path__ + "img/010_columbus.7a91ba7b.jpg";